import { registerSW } from "virtual:pwa-register"
import { getRuntimeMode } from "@/ts/runtime-info"

export function initPwa(): void {
        if (getRuntimeMode() === "native-shell" || !("serviceWorker" in navigator))  return

        try {
                const updateSW = registerSW({
                        onNeedRefresh() {
                                console.info("[pwa] Доступна новая версия приложения. Применяем обновление.")
                                void updateSW(true)
                        },
                        onOfflineReady() {
                                console.info("[pwa] Оболочка приложения готова к работе офлайн.")
                        },
                })
        } catch (error) {
                console.warn("[pwa] Не удалось зарегистрировать Service Worker.", error)
        }
}
